/**
 * Created by 「 peng.xie 」  on 2018/12/19.
 * thanks.
 */
import newRouter from './router';
import newUtils from './util';
import remJs from './rem';

export default ({
    newRouter,
    newUtils,
    remJs,
});
